import { render, staticRenderFns } from "./authority.vue?vue&type=template&id=47306809"
import script from "./authority.vue?vue&type=script&lang=js"
export * from "./authority.vue?vue&type=script&lang=js"
import style0 from "./authority.vue?vue&type=style&index=0&id=47306809&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports